import { Reveal } from './Reveal';
import { faqs } from '../data/site';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="py-24 sm:py-32 bg-white"
  >
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-blue-600 mb-4">
          05 — Dúvidas frequentes
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight">
          Perguntas que todo mundo faz.
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-slate-200"
            >
              <AccordionTrigger className="text-left font-display font-bold text-base sm:text-lg text-slate-800 hover:text-blue-600 hover:no-underline py-6">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-500 text-sm sm:text-base leading-relaxed pb-6">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
